/** Responsibility: poll hub health for the header indicator. */
import { useQuery } from '@tanstack/react-query';
import { hubApi } from '../client';

export function useHealth() {
  return useQuery({
    queryKey: ['health'],
    queryFn: hubApi.health,
    refetchInterval: 30_000,
    retry: false,
  });
}
